import React from 'react';
import { useTranslation } from 'react-i18next';
import LayoutNavbar from '@root/components/LayoutNavbar';
import BillDetail from '@root/containers/Bill/BillDetail';

const BillDetailPage = () => {
  const { t } = useTranslation();

  return (
    <LayoutNavbar
      navbarProps={{
        title: t('bills_detail'),
      }}
    >
      <BillDetail />
    </LayoutNavbar>
  );
};

export default BillDetailPage;
